import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Input,
  Row,
  UncontrolledCollapse,
} from "reactstrap";
import React, { useState } from "react";
import { helpers } from "../helpers";

export const ReportDetailsView = ({
  report,
  setCompletingReview,
  setReview,
}) => {
  const [isMessageToSenderSet, setIsMessageToSenderSet] = useState(false);
  const [isMessageToContentCreatorSet, setIsMessageToContentCreatorSet] =
    useState(false);
  const [isNoteToBlaggomSet, setIsNoteToBlaggomSet] = useState(false);
  const [isBlockContentSet, setIsBlockContentSet] = useState(false);

  const areAllRequiredFieldsSet =
    isNoteToBlaggomSet &&
    isMessageToContentCreatorSet &&
    isMessageToSenderSet &&
    isBlockContentSet;

  const [messageToSender, setMessageToSender] = useState("");
  const [messageToContentCreator, setMessageToContentCreator] = useState("");
  const [noteToBlagoom, setNoteToBlagoom] = useState("");
  const [blockContent, setBlockContent] = useState(null);

  const contentUrl = helpers.resolveContentUrl(report);

  return (
    <UncontrolledCollapse
      tag={"div"}
      colSpan={7}
      toggler={"#toggler" + report._id}
      style={{
        backgroundColor: "grey",
      }}
    >
      <Row
        style={{
          display: "flex",
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingBottom: "20px",
          paddingRight: "10px",
        }}
      >
        <Card>
          <CardHeader>Inhalt</CardHeader>
          <CardBody>{report.contentDetails}</CardBody>
        </Card>
      </Row>
      <Row
        style={{
          display: "flex",
          paddingTop: "10px",
          paddingLeft: "10px",
          paddingBottom: "20px",
          paddingRight: "10px",
        }}
      >
        <Col>
          <Card>
            <CardHeader>Beschreibung des Melders </CardHeader>
            <CardBody>{report.description}</CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Nachricht an Melder </CardHeader>
            <CardBody>
              <Input
                type="textarea"
                name="text"
                id="exampleText"
                style={{
                  height: "200px",
                }}
                value={messageToSender}
                onChange={(event) => {
                  setMessageToSender(event.target.value);
                  setIsMessageToSenderSet(false);
                }}
              />
            </CardBody>
            <CardFooter
              style={{
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                color={isMessageToSenderSet ? "primary" : "secondary"}
                size="sm"
                onClick={() => setIsMessageToSenderSet(true)}
              >
                fertig
              </Button>
            </CardFooter>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Nachricht an Content-Creator </CardHeader>
            <CardBody>
              <Input
                type="textarea"
                name="text"
                id="exampleText"
                style={{
                  height: "200px",
                }}
                value={messageToContentCreator}
                onChange={(event) => {
                  setMessageToContentCreator(event.target.value);
                  setIsMessageToContentCreatorSet(false);
                }}
              />
            </CardBody>
            <CardFooter
              style={{
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                color={isMessageToContentCreatorSet ? "primary" : "secondary"}
                size="sm"
                onClick={() => setIsMessageToContentCreatorSet(true)}
              >
                fertig
              </Button>
            </CardFooter>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>Notiz an Blagoom (optional)</CardHeader>
            <CardBody>
              <Input
                type="textarea"
                name="text"
                id="exampleText"
                style={{
                  height: "200px",
                }}
                value={noteToBlagoom}
                onChange={(event) => {
                  setNoteToBlagoom(event.target.value);
                  setIsNoteToBlaggomSet(false);
                }}
              />
            </CardBody>
            <CardFooter
              style={{
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <Button
                color={isNoteToBlaggomSet ? "primary" : "secondary"}
                size="sm"
                onClick={() => setIsNoteToBlaggomSet(true)}
              >
                fertig
              </Button>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "30px",
          paddingLeft: "20px",
        }}
      >
        <div>
          <a href={contentUrl} target="_blank">
            <Button color="secondary">Link zum Content</Button>
          </a>
        </div>
        <div>
          <Button
            color={blockContent === false ? "primary" : "secondary"}
            onClick={() => {
              setIsBlockContentSet(true);
              setBlockContent(false);
            }}
          >
            Nicht Sperren
          </Button>
          <Button
            color={!blockContent === false ? "primary" : "secondary"}
            onClick={() => {
              setIsBlockContentSet(true);
              setBlockContent(true);
            }}
          >
            Sperren
          </Button>
        </div>
        <div>
          <Button
            color="success"
            disabled={!areAllRequiredFieldsSet}
            onClick={() => {
              setCompletingReview(true);
              setReview({
                reportId: report._id,
                noteToBlagoom,
                messageToReporter: messageToSender,
                messageToContentCreator,
                blockContent,
              });
            }}
          >
            Complete
          </Button>
        </div>
      </Row>
    </UncontrolledCollapse>
  );
};
